import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import auth from './module/auth';

const reducer = combineReducers({
  auth
});

const store = createStore(reducer, applyMiddleware(thunk));

export default store;
